export default text =>
  `${'(' +
    text.substr(0, 3) +
    ') ' +
    text.substr(3, 3) +
    ' ' +
    text.substr(6, 2) +
    ' ' +
    text.substr(8, 2)}`;
